import { createBrowserClient } from "@supabase/ssr";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

export const createClient = () =>
  createBrowserClient(
    supabaseUrl!,
    supabaseKey!,
  );

// Lazy singleton — most components want a shared client, not a fresh one.
let _client: ReturnType<typeof createBrowserClient> | null = null;
export const getSupabase = () => {
  if (!_client) _client = createBrowserClient(supabaseUrl!, supabaseKey!);
  return _client;
};
